export default "__VITE_PUBLIC_ASSET__ae990ae7__"